import { useState } from 'react'
import AboutModal from './AboutModal'
import Button from '@mui/material/Button'
import InfoIcon from '@mui/icons-material/InfoTwoTone'
import './About.css'

const About = () => {
    const [isInfoBoxVisible, setInfoBoxVisibility] = useState(false)

    const showInfoBox = () => {
        setInfoBoxVisibility(true)
    }

    const hideInfoBox = () => {
        setInfoBoxVisibility(false)
    }

    return (
        <>
            <div className="about-section">
                <Button onClick={showInfoBox}>
                    <InfoIcon className="icon" color="primary" />
                </Button>
            </div>
            <AboutModal onClose={hideInfoBox} open={isInfoBoxVisible} />
        </>
    )
}

export default About
